import React from 'react';
import {
  AboutSection,
  Container,
  AboutContent,
  AboutText,
  SectionTitle,
  AboutDescription,
  AboutBenefits,
  AboutImage
} from './About.styles.jsx';

const About = () => {
  return (
    <AboutSection id="despre">
      <Container>
        <AboutContent>
          <AboutText>
            <SectionTitle>Despre Instalații Pro</SectionTitle>
            <AboutDescription>
              <strong style={{ color: '#2563eb' }}> Instalații Pro</strong> oferă servicii profesionale de calitate superioară 
              pentru casele și afacerile din Ploiești, București și împrejurimi.
            </AboutDescription>

            <AboutBenefits>
              <h3>De ce să ne alegi pe noi?</h3>
              <ul>
                <li>✅ <strong>Echipă specializată</strong> - Tehnicieni cu experiență vastă</li>
                <li>✅ <strong>Materiale de calitate</strong> - Folosim doar produse premium</li>
                <li>✅ <strong>Prețuri competitive</strong> - Oferte transparente și corecte</li>
                <li>✅ <strong>Intervenție rapidă</strong> - Disponibili 24/7 pentru urgențe</li>
                <li>✅ <strong>Consultații gratuite</strong> - Te ajutăm să alegi cea mai bună soluție</li>
              </ul>
            </AboutBenefits>
          </AboutText>

          <AboutImage>
            <img 
              src="/9-heyclipart-dl/9-male-handyman.png" 
              alt="Servicii Instalații" 
              style={{ maxWidth: '100%', height: 'auto', borderRadius: '16px' }}
            />
          </AboutImage>
        </AboutContent>
      </Container>
    </AboutSection>
  );
};

export default About;

